import { initialFiltersState, newsFeedFilterReducer } from "../../../admin_views/filters/ProspectBasedFilters/reducer/newsFeedFilterReducer";
import { datepicker_input_format } from "../../../utils/dateUtils";
import { POST_TYPE_MAP } from "../high_confidence_results";

export const postTypes = [
    { label: "All", key: "all" },
    { label: "News Results", key: "articles" },
    { label: "Job Updates", key: "Job_Updates" },
    { label: "SEC Filings", key: "SEC_Filings"}
];
export const feed_data_params = ({
    filtersState = initialFiltersState,
    allFilterTabs
}) => {
    const { postType, dropDownFilterlist, searchTerm } = filtersState
    let { filtersSelected } = filtersState;
    let range_params = {}
    Object.keys(filtersState.dateRanges).forEach(k => {
        if (filtersState.dateRanges[k].value.from && filtersState.dateRanges[k].value.to) {
            let from = filtersState.dateRanges[k].value.from;
            let to = filtersState.dateRanges[k].value.to;
            range_params[k] = { from: datepicker_input_format(from), to: datepicker_input_format(to) };
        }
    })

    let data_params = {
        tags: filtersSelected.tags,
        assigned: filtersSelected.assigns,
        title: filtersSelected.title,
        company: filtersSelected.company,
        college: filtersSelected.college,
        location: filtersSelected.location,
        mentioned_for: filtersSelected.mentioned_for,
        sec_category: filtersSelected.sec_category,
        miscellaneous: filtersSelected.miscellaneous,
        score_tags: filtersSelected.score_tags,
        graduation_year: filtersSelected.graduation_year,
        view_type: dropDownFilterlist.viewType,
        date_ranges: range_params,
        searchTerm: searchTerm,
        sort: filtersSelected.sort?.[0]
    }
    data_params.post_type = POST_TYPE_MAP[postType];

    allFilterTabs?.filter(item => item.is_custom).forEach(element => {
        if (filtersSelected[element.tab_key]?.length > 0) {
            if (!data_params["custom_option_ids"]) data_params["custom_option_ids"] = {};
            data_params["custom_option_ids"][element.tab_key] = filtersSelected[element.tab_key]
        }
    });
    data_params.custom_option_ids = data_params.custom_option_ids ? JSON.stringify(data_params.custom_option_ids) : null;

    if (dropDownFilterlist.containComment == 'contains_comments') {
        data_params["has_comments"] = true;
    }
    else if (dropDownFilterlist.containComment == 'no_comments') {
        data_params["has_comments"] = false;
    }

    data_params["review"] = dropDownFilterlist.review
    return data_params
}

const prospect_data_params = ({
    filtersState,
    allFilterTabs
}) => {
    let { filtersSelected } = filtersState
    let data_params = {
        tags: filtersSelected.tags,
        assigned: filtersSelected.assigns,
        title: filtersSelected.title,
        company: filtersSelected.company,
        college: filtersSelected.college,
        location: filtersSelected.location,
        miscellaneous: filtersSelected.miscellaneous,
        query: filtersState.searchTerm,
        graduation_year: filtersSelected.graduation_year,
    }
    allFilterTabs.filter(item => item.is_custom).forEach(element => {
        if (filtersSelected[element.tab_key]?.length > 0) {
            if (!data_params["custom_option_ids"]) data_params["custom_option_ids"] = {};
            data_params["custom_option_ids"][element.tab_key] = filtersSelected[element.tab_key]
        }
    });
    data_params.custom_option_ids = data_params.custom_option_ids ? JSON.stringify(data_params.custom_option_ids) : null;
    return data_params
}

const directory_data_params = ({
    filtersState,
    allFilterTabs
}) => {
    let filterType = 'include'
    let data_params = Object.keys(filtersState.filtersSelected[filterType]).reduce((r, tab_key) => {
        r[tab_key] = filtersState.filtersSelected[filterType][tab_key].map(v => (typeof v.value === "object" ? JSON.stringify(v.value) : v.value));
        return r;
    }, {});
    return data_params
}

const article_data_params = ({
    filtersState
}) => {
    let range_params = {}
    let { filtersSelected } = filtersState;
    Object.keys(filtersState.dateRanges).forEach(k => {
        if (filtersState.dateRanges[k].value.from && filtersState.dateRanges[k].value.to) {
            let from = filtersState.dateRanges[k].value.from
            let to = filtersState.dateRanges[k].value.to
            range_params[k] = { from: datepicker_input_format(from), to: datepicker_input_format(to) };
        }
    })
    let score_tags = filtersSelected.score_tags.map(item => ({ value: item }))
    var params = {
        date_ranges: range_params,
        tags: filtersSelected.tags,
        assigned: filtersSelected.assigns,
        title: filtersSelected.title,
        company: filtersSelected.company,
        college: filtersSelected.college,
        location: filtersSelected.location,
        mentioned_for: filtersSelected.mentioned_for,
        graduation_year: filtersSelected.graduation_year,
        sort: filtersSelected.sort?.[0],
        score_tags: score_tags
    }
    return params
}

const smartarticles_data_params = ({
    filtersState
}) => {
    let range_params = {}
    let { filtersSelected } = filtersState;
    Object.keys(filtersState.dateRanges).forEach(k => {
        if (filtersState.dateRanges[k].value.from && filtersState.dateRanges[k].value.to) {
            let from = filtersState.dateRanges[k].value.from
            let to = filtersState.dateRanges[k].value.to
            range_params[k] = { from: datepicker_input_format(from), to: datepicker_input_format(to) };
        }
    })
    var params = {
        date_ranges: range_params,
        tags: filtersSelected.include.tags,
    }
    return params
}
export const get_data_params = (type, props) => {
    if (type === 'high') return feed_data_params(props)
    if (type === 'low' || type === 'mid') return article_data_params(props)
    if (type === 'prospects') return prospect_data_params(props)
    if (type === 'directory') return directory_data_params(props)
    if (type === 'smartpublish') return smartarticles_data_params(props)
    return {}
}
